function Footer() {
    $(window).scroll(() =>
        $(".btnUp").toggleClass("show", $(window).scrollTop() > 132)
    );

    $(".btnUp").click(() => $("html, body").animate({ scrollTop: 0 }, 600));

    $(document).ready(function () {
        // Kullanıcı cihazını kontrol et
        const isMobileOrTablet = /Mobi|Android|iPhone|iPad|iPod|Tablet/i.test(
            navigator.userAgent
        );

        if (isMobileOrTablet) {
            $(".device").addClass("show");
        }
    });
}
Footer();
